import { Button, Typography } from "antd";
import AddChannelForm from "./AddChannelForm";
import ChannelList from "./ChannelList";
import { PlayCircleOutlined } from "@ant-design/icons";
import { PLATFORM_LINKS } from "../assets/data";
import CopyablePlatformLinks from "./CopyablePlatformLinks";
import SocialUsernameForm from "./SocialUsernameForm";

const ChannelSettings = ({
  step,
  setStep,
  discordChannels,
  telegramChannels,
  channelId,
  setChannelId,
  channelName,
  setChannelName,
  sport,
  setSport,
  addChannel,
  removeChannel,
  setIsTutorialModalVisible,
  updateChannel,
  form,
  currentDiscord,
  currentTelegram
}) => {

  return (
    <div>
      <div className="flex justify-between">
        <div className="flex gap-2">
          <Button
            className={`text-left flex items-center ${
              step === "discord" ? "bg-[#F2F4F7]" : "hover:bg-gray-100"
            } border-none rounded`}
            type="default"
            onClick={() => setStep("discord")}
          >
            Discord
          </Button>
          <Button
            className={`text-left flex items-center ${
              step === "telegram" ? "bg-[#F2F4F7]" : "hover:bg-gray-100"
            } border-none rounded`}
            type="default"
            onClick={() => setStep("telegram")}
          >
            Telegram
          </Button>
        </div>
        <Button
          icon={<PlayCircleOutlined className="text-black" />}
          type="text"
          className="bg-[#F2F4F7] text-black"
          onClick={() => setIsTutorialModalVisible(true)}
        >
          <span className="hidden md:inline">Tutorial</span>
        </Button>
      </div>

      <SocialUsernameForm
        step={step}
        form={form}
        currentDiscord={currentDiscord}
        currentTelegram={currentTelegram}
      />

      <div className="mb-3 border-t border-dashed border-gray-400" />
      <AddChannelForm
        step={step}
        channelId={channelId}
        setChannelId={setChannelId}
        channelName={channelName}
        setChannelName={setChannelName}
        sport={sport}
        setSport={setSport}
        addChannel={addChannel}
      />

      <Typography.Title level={5} className="mt-6 text-left">
        Added Channels
      </Typography.Title>
      <ChannelList
        channels={step === "discord" ? discordChannels : telegramChannels}
        step={step}
        removeChannel={removeChannel}
        isSettings={true}
        onChannelUpdate={updateChannel}
      />

      <div className="mt-6 mb-3 border-t border-dashed border-gray-400" />

      <div className="mt-0">
        <CopyablePlatformLinks 
          platform={step}
          link={PLATFORM_LINKS[step]}
          label={step === "discord" ? "Discord Bot Link" : "Telegram Bot Link"}
        />
      </div>
    </div>  
  );
};

export default ChannelSettings;